window.addEventListener("load", (event) => {
    if (window.innerWidth <= 600) {

        let arr_EN = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z','А', 'Б', 'В', 'Г', 'Ґ', 'Д', 'Е', 'Ж', 'З', 'И', 'І', 'Ї', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ю', 'Я'];
        /*let arr_UA = ['А', 'Б', 'В', 'Г', 'Ґ', 'Д', 'Е', 'Ж', 'З', 'И', 'І', 'Ї', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ю', 'Я'];*/
        let arr_Lang = [arr_EN];
        let brandsOb = [];
        let obj = [];

        $('.brandsName').each(function () {

            brandsOb.push($(this).data('title'));
            obj.push(
                {
                    title: $(this).data('title'),
                    category_id: $(this).data('category_id'),
                    link: $(this).data('link')
                }
            );
        });

        $.each(arr_Lang, function (indexLang, valueLang) {
            $.each(valueLang, function (index, value) {
                let i = true;
                $.each(obj, function (indexName, brandsName) {

                    let brandSubst = brandsName.title.substr(0, 1);
                    let $newDiv = $("<div>").addClass('brands_letter ' + 'brands' + index + ' col-6' + ' py-2').html('<h3>' + value + '</h3>');
                    if (brandSubst === value) {

                        if (i === true) {
                            $('.sortBrands_main').append($newDiv);
                            i = false;
                        }
                        $('.brands' + index + '').append($('<a>' + brandsName.title + '</br>' + '<a>').addClass('all_brands').attr({
                                'data-category' : brandsName.category_id,

                            }
                        ).prop('href',brandsName.link));

                    }
                });
            });

        });

        $('.chosen_category').click(function () {
            $('.chosen_category').each(function (){
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            let chose = $(this).data('catid');
            if(chose !=='all') {
                $('.all_brands').each(function () {
                    let elem_id = $(this).data('category');
                    if (chose !== elem_id) {
                        $(this).hide(500).addClass('hide');

                    } else {
                        $(this).show(500).removeClass('hide');

                    }
                });
            }else {
                $('.all_brands').each(function () {
                    $(this).show(500).removeClass('hide');
                });
            }
            $('.brands_letter').each(function () {
                if ($(this).find('.all_brands').length === $(this).find('.hide').length) {

                    $(this).hide(500)

                } else {
                    $(this).show(500)

                }
            })
        });


        $('#basicBox').remove();
        $('.chosen_category[data-catid="all"]').trigger('click');

        window.onpopstate = function () {
            document.location.reload();
        };
    } else {

        let arr_EN = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z','А', 'Б', 'В', 'Г', 'Ґ', 'Д', 'Е', 'Ж', 'З', 'И', 'І', 'Ї', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ю', 'Я'];
        /*let arr_UA = ['А', 'Б', 'В', 'Г', 'Ґ', 'Д', 'Е', 'Ж', 'З', 'И', 'І', 'Ї', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ю', 'Я'];*/
        let arr_Lang = [arr_EN];
        let brandsOb = [];
        let obj = [];

        $('.brandsName').each(function () {

            brandsOb.push($(this).data('title'));
            obj.push(
                {
                    title: $(this).data('title'),
                    category_id: $(this).data('category_id'),
                    link: $(this).data('link')
                }
            );
        });

        $.each(arr_Lang, function (indexLang, valueLang) {
            $.each(valueLang, function (index, value) {
                let i = true;
                $.each(obj, function (indexName, brandsName) {
                    let brandSubst = brandsName.title.substr(0, 1);
                    let $newDiv = $("<div>").addClass('brands_letter ' + 'brands' + index + ' col-4 col-lg-3 col-md-4' + ' py-2').html('<h3>' + value + '</h3>');
                    if (brandSubst === value) {
                        if (i === true) {
                            $('.sortBrands_main').append($newDiv);
                            i = false;
                        }
                        $('.brands' + index + '').append($('<a>' + brandsName.title + '</br>' + '<a>').addClass('all_brands').attr({
                                'data-category' : brandsName.category_id,

                            }
                        ).prop('href',brandsName.link));
                    }
                });
            });
        });

        $('.chosen_category').click(function () {
            $('.chosen_category').each(function (){
                $(this).removeClass('active');
            });
            $(this).addClass('active');
            let chose = $(this).data('catid');
            if(chose !== 'all') {
                $('.all_brands').each(function () {
                    let elem_id = $(this).data('category');
                    if (chose !== elem_id) {
                        $(this).hide(500).addClass('hide');

                    } else {
                        $(this).show(500).removeClass('hide');

                    }
                });
            }else {
                $('.all_brands').each(function () {
                    $(this).show(500).removeClass('hide');
                });
            }
            $('.brands_letter').each(function () {
                if ($(this).find('.all_brands').length === $(this).find('.hide').length) {

                    $(this).hide(500)

                } else {
                    $(this).show(500)

                }
            })
        });


        $('#basicBox').remove();
        $('.chosen_category[data-catid="all"]').trigger('click');

        window.onpopstate = function () {
            document.location.reload();
        };
    }
})

